// extracted by mini-css-extract-plugin
export default {"container":"Register_container__C3iVQ","content":"Register_content__s9Uqd"};